export default function(gantt){
	return gantt.config.smart_rendering && gantt._smart_render;
};